import { IBudgetApiPayload, IBudgetService, IClientData, IVehicleData } from '../types';
import { calculateBudgetTotals, parseHourMeter, parseNumber, roundMoney } from './budgetCalculations';

interface IBuildApiPayloadParams {
  occurrenceId: string;
  recipient: string | undefined;
  clientData: IClientData | undefined;
  vehicleData: IVehicleData | undefined;
  services: IBudgetService[];
  proposalServices?: IBudgetService[];
  truckerPayPlanId?: string;
  subscriptionBalanceToApply?: number;
}

export const buildBudgetApiPayload = (params: IBuildApiPayloadParams): IBudgetApiPayload => {
  const { occurrenceId, recipient, clientData, vehicleData, services, proposalServices, truckerPayPlanId, subscriptionBalanceToApply } = params;

  const { 
    services: mappedServices, 
    subtotal, 
    discount 
  } = calculateBudgetTotals(services);

  const subscriptionApplied = subscriptionBalanceToApply ?? 0;
  const netTotal = roundMoney(subtotal - discount - subscriptionApplied);

  let mappedProposalServices: IBudgetApiPayload['proposalServices'] = undefined;
  if (proposalServices && proposalServices.length > 0) {
    const calculated = calculateBudgetTotals(proposalServices);
    mappedProposalServices = calculated.services;
  }
  const payload: IBudgetApiPayload = {
    occurrenceProtocolNumber: vehicleData?.protocolNumber || '',
    occurrenceUuid: occurrenceId,
    recipient: recipient || '',
    truckerPayPlanId,

    customer: {
      name: clientData?.name || '',
      email: clientData?.email || '',
      phone: clientData?.phone || '',
    },

    vehicle: {
      chassis: vehicleData?.chassis,
      licensePlate: vehicleData?.licensePlate?.slice(0, 20),
      year: parseNumber(vehicleData?.year),
      model: vehicleData?.model,
      odometer: parseNumber(vehicleData?.odometer?.replaceAll(/[^\d]/g, '')),
      hourMeter: parseHourMeter(vehicleData?.hourmeter),
      contractNumber: vehicleData?.contractNumber || null,
    },

    services: mappedServices,
    proposalServices: mappedProposalServices,
    subtotal,
    discount,
    netTotal,
    subscriptionBalanceToApply: roundMoney(subscriptionApplied),
    observation: undefined,
  };

  return payload;
};
